import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

/**
 * 更新交易状态（管理员专用）
 * @param {number} transaction_id - 交易ID
 * @param {string} action - 操作类型：review(审核), confirm(确认到账), refund(退款), confirm_refund(确认退款), cancel_review(取消审核), cancel_refund(取消退款), update_date(更新日期)
 * @param {string} transaction_date - 交易日期（可选，仅在 action 为 update_date 时使用）
 * @returns {Promise}
 */
export const update_transaction_status = (transaction_id, action, transaction_date = null) => {
  // 后端使用POST方法，参数从Body JSON传递
  const payload = {
    transaction_id,
    action,
  };
  
  // 如果提供了交易日期，添加到请求中
  if (transaction_date) {
    payload.transaction_date = transaction_date;
  }
  
  return api.post(`${ApiEndpointConstants.UPDATE_TRANSACTION_STATUS}`, payload);
};

